"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferBottomCol = exports.OfferTags = exports.OfferFooter = exports.StyledTag = exports.StyledTimestamp = exports.IconWrapper = exports.ContentWrapper = exports.OfferIntoTagGroup = exports.PromotedBadge = exports.InfoTag = exports.LinkWrapper = exports.CompanyWrapper = exports.Title = exports.ImageWrapper = exports.OfferBox = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const timestamp_1 = __importDefault(require("@src/components/modules/global/timestamp"));
const elements_1 = require("@src/components/elements");
const polished_1 = require("polished");
exports.OfferBox = styled_components_1.default.article `
	padding: 1.5rem 1.5rem 1rem 1.5rem;
	position: relative;
	${({ isPromoted }) => isPromoted &&
    (0, styled_components_1.css) `
			border: 1px solid ${({ theme }) => theme.color.premium};
			border-radius: ${({ theme }) => theme.borderRadius.base};
		`}

	${(0, styled_breakpoints_1.down)('sm')} {
		text-align: center;
	}
`;
exports.ImageWrapper = styled_components_1.default.div `
	margin: 0 auto 1rem;
	${(0, styled_breakpoints_1.up)('sm')} {
		float: right;
		margin: 0 0 0 2rem;
		text-align: right;
	}
`;
exports.Title = styled_components_1.default.h1 `
	color: ${({ theme }) => theme.color.brand3};
	margin: 0 0 0.2rem 0;
	padding: 0;
	-ms-word-break: break-all;
	-ms-word-wrap: break-all;
	-webkit-word-break: break-word;
	-webkit-word-wrap: break-word;
	word-break: break-word;
	word-wrap: break-word;
	-webkit-hyphens: auto;
	-moz-hyphens: auto;
	hyphens: auto;
`;
exports.CompanyWrapper = styled_components_1.default.div `
	-ms-word-break: break-all;
	-ms-word-wrap: break-all;
	-webkit-word-break: break-word;
	-webkit-word-wrap: break-word;
	word-break: break-word;
	word-wrap: break-word;
	-webkit-hyphens: auto;
	-moz-hyphens: auto;
	hyphens: auto;
	color: ${({ theme }) => theme.color.gray7};
	font-weight: 600;
	font-size: 1.2rem;
	margin-bottom: 1rem;
`;
exports.LinkWrapper = (0, styled_components_1.default)(elements_1.Link) `
	position: relative;
	display: block;
	&:link,
	&:visited,
	&:active,
	&:hover,
	&:focus {
		text-decoration: inherit;
		color: inherit;
	}
`;
exports.InfoTag = styled_components_1.default.div `
	-ms-word-break: break-all;
	-ms-word-wrap: break-all;
	-webkit-word-break: break-word;
	-webkit-word-wrap: break-word;
	word-break: break-word;
	word-wrap: break-word;
	-webkit-hyphens: auto;
	-moz-hyphens: auto;
	hyphens: auto;
	align-items: center;
	font-size: 0.8rem;
	padding: 0.5rem;
	display: inline-flex;
	background: ${({ theme }) => theme.color.gray3};

	border-radius: 4px;
	border-bottom: 1px solid white;
	color: ${({ theme }) => theme.color.gray8};

	.icon > svg {
		height: 1rem;
		margin-right: 0.7rem;
	}
`;
exports.PromotedBadge = styled_components_1.default.div `
	position: absolute;
	width: max-content;
	display: inline-flex;
	align-items: center;
	padding: 0.25rem 0.75rem;
	/* border: 1px solid ${({ theme }) => (0, polished_1.darken)(0.4, theme.color.premium)}; */
	border-radius: ${({ theme }) => theme.borderRadius.base};
	background-color: ${({ theme }) => theme.color.premium};
	color: ${({ theme }) => theme.color.white};
	top: -15.5px;
	right: 3rem;
`;
exports.OfferIntoTagGroup = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	width: fit-content;

	${(0, styled_breakpoints_1.down)('sm')} {
		width: 100%;
	}
`;
exports.ContentWrapper = styled_components_1.default.div `
	width: 100%;
	display: inline-flex;
	justify-content: end;
	align-items: center;

	${(0, styled_breakpoints_1.down)('md')} {
		justify-content: space-between;
		align-items: flex-end;
	}
`;
exports.IconWrapper = styled_components_1.default.span `
	display: flex;
	align-items: center;
	svg {
		color: ${({ theme }) => theme.color.brand1};
		width: 16px;
		g {
			stroke: ${({ theme }) => theme.color.brand1};
		}
		path {
			stroke: ${({ theme }) => theme.color.brand1};
		}
	}
`;
exports.StyledTimestamp = (0, styled_components_1.default)(timestamp_1.default) `
	text-align: right;
	font-size: 0.8rem;
	margin-right: 0.5rem;
	color: ${({ theme }) => theme.color.gray5};
`;
exports.StyledTag = (0, styled_components_1.default)(elements_1.Tag) `
	display: flex;
	justify-content: start;
	align-items: center;
`;
exports.OfferFooter = styled_components_1.default.div `
	margin-top: 1rem;
	display: flex;
	justify-content: space-between;

	${(0, styled_breakpoints_1.down)('xs')} {
		flex-direction: column;
	}
`;
exports.OfferTags = styled_components_1.default.div `
	display: flex;
	align-items: flex-end;
	justify-content: flex-start;

	${(0, styled_breakpoints_1.down)('sm')} {
		flex: 1;
		flex-wrap: wrap;
		align-content: end;

		.ant-tag {
			margin-top: 4px;
		}
	}

	${(0, styled_breakpoints_1.down)('xs')} {
		margin-bottom: 0.5rem;
	}
`;
exports.OfferBottomCol = styled_components_1.default.div `
	display: flex;
	justify-content: flex-end;
`;
